module.exports = new __parcel__URL__("rating-20.698d45bf.png").toString();